import { useTranslation } from 'react-i18next';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

/**
 * Aviso exibido no lugar da árvore descartada por uma falha de render.
 *
 * Fica separado do boundary porque depende de `useTranslation`, e hook não existe em
 * componente de classe. A aparência espelha o `Alert severity="error"` já usado no aviso
 * de falha de montagem do Angular, para que falha de carregamento tenha a mesma cara em
 * qualquer ponto da aplicação.
 */
export function ErrorFallback(): JSX.Element {
  const { t } = useTranslation();

  // Recarregar, e não navegar para a raiz: a rota corrente vive no hash, então o reload
  // preserva onde o usuário estava e dá à tela uma segunda chance no mesmo contexto.
  const handleReload = (): void => {
    window.location.reload();
  };

  return (
    <Alert severity="error" sx={{ m: 3 }}>
      <AlertTitle>{t('errorBoundary.title')}</AlertTitle>
      {t('errorBoundary.message')}
      <Box sx={{ mt: 2 }}>
        <Button color="error" variant="outlined" size="small" onClick={handleReload}>
          {t('errorBoundary.reload')}
        </Button>
      </Box>
    </Alert>
  );
}
